export default function useTranslate(intl, key) {
  return intl.formatMessage({id:key})
}

